import React, { useState } from "react";
import "./Archive.css";
import HoleOfFame from "./ArchiveTabs/HoleOfFame";
import ProblemArchive from "./ArchiveTabs/ProblemArchive/ProblemArchive";
import Links from "./ArchiveTabs/Links";


const Archive = () => {
  const [Search, setSearch] = useState("");
  const [ActiveTab, setActiveTab] = useState("Hole Of Fame");

  const renderTable = () => {
    switch (ActiveTab) {
      case "Hole Of Fame":
        return <HoleOfFame ActiveTab={ActiveTab} Search={Search} setSearch={setSearch} />;
      case "Problem Archive":
        return <ProblemArchive />;
      case "Links":
        return <Links />;
      default:
        return null;
    }
  };

  return (
    <div className="archive-table-container">
      <h1>📚 Archive</h1>

      <p className="Purpose">
        <b>Puropose : </b>The Archive section is designed to preserve the
        mathematical journey of the community, serving both as a record of
        achievement and a learning hub. It allows students to revisit past
        problem-solving experiences, reflect on their progress, and draw
        inspiration from notable performances.
      </p>

      <div className="Archive-buttons">
        <button
          className={ActiveTab === "Hole Of Fame" ? "active" : ""}
          onClick={() => setActiveTab("Hole Of Fame")}
        >
          Hall Of Fame
        </button>
        <button
          className={ActiveTab === "Problem Archive" ? "active" : ""}
          onClick={() => {
            setSearch('')
            setActiveTab("Problem Archive")
            }
          }
        >
          Problems Archive
        </button>
        <button
          className={ActiveTab === "Links" ? "active" : ""}
          onClick={() => {
            setSearch('')
            setActiveTab("Links")
          }}
        >
          Usefull Links
        </button>
      </div>
      
      <div className="tabs-content">{renderTable()}</div>
    </div>
  );
};

export default Archive;
